import { currentStoreSelector } from '@state/features/storelocator.selectors';
import analytics from '@utils/analytics';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import StoreAddress from './StoreAddress';
import StoreLocatorMap from './StoreLocatorMap';
const StoreBoutiquesNearby = (props) => {
    const { t } = useTranslation();
    const { stores } = props;
    const [selectedStore, setSelectedStore] = useState(stores[0]);
    const { baseUrl } = useSelector((state) => state.storelocator);
    const currentStore = useSelector(currentStoreSelector);
    return (React.createElement("div", { className: "row justify-center boutiques-nearby" },
        React.createElement("div", { className: "col-12 wrapper-title" },
            React.createElement("h2", { className: "section-title" }, t('storelocator.boutiquesnearby')),
            React.createElement("a", { href: `${baseUrl}/storelocator`, onClick: () => analytics.storelocatorStoreCta(currentStore.name, 'find a boutique'), className: "button button--tertiary button--arrow-right " }, t('storelocator.findboutique'))),
        React.createElement("div", { className: "col-sm-8 col-md-3" },
            React.createElement("div", { className: "nearby-store-details" },
                React.createElement("button", { onClick: () => {
                        if (selectedStore) {
                            analytics.storelocatorSelect(selectedStore.name);
                        }
                    } },
                    React.createElement("h3", { className: "title" }, selectedStore.name),
                    React.createElement(StoreAddress, { store: selectedStore, hidename: true, showphone: true, showmail: true })),
                React.createElement("a", { href: `${baseUrl}/storelocator/${selectedStore.slug}`, onClick: () => analytics.storelocatorStoreCta(selectedStore.name, 'view boutique'), className: "button button--secondary" },
                    React.createElement("span", null, t('button.viewdetails'))))),
        React.createElement("div", { className: "col-sm-8 col-md-5" },
            React.createElement(StoreLocatorMap, Object.assign({}, props, { localMap: true, stores: stores, currentStore: selectedStore, setCurrentStore: (storeId) => setSelectedStore(stores.find((store) => store.ID === storeId)) })))));
};
export default StoreBoutiquesNearby;
